<template>
  <div
    class="rounded-lg flex flex-col"
    :class="[backgroundColor, fontColor]"
    data-testid="student-profile-header"
  >
    <div
      v-if="showLeftBorder"
      class="p-5 rounded-l-lg"
      :style="{ borderLeft: `8px solid ${leftBorderColor}` }"
      data-testid="profile-header-container"
    >
      <h1
        v-if="data.name"
        class="text-xl font-bold"
        :class="fontColor"
        data-testid="profile-name"
      >
        <span
          class="cursor-pointer hover:text-blue-600 transition-all inline-block"
          @click="() => data.name && copyToClipboard(data.name)"
        >
          {{ data.name }}
        </span>
      </h1>
      <div class="flex flex-wrap gap-4 mt-4" data-testid="profile-fields">
        <FieldDisplay
          v-for="field in fields"
          :key="field.key"
          :label="field.label"
          :value="data[field.key]"
          :field-key="field.key"
          :format-type="field.formatType || 'text'"
          :locale="field.locale || 'en-US'"
          :data-testid="`field-display-${field.key}`"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { useToast } from "vue-toast-notification";
import FieldDisplay from "./FieldDisplay.vue";

defineProps({
  data: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  fields: {
    type: Array,
    required: true,
  },
  fontColor: {
    type: String,
    default: "text-university-primary",
  },
  backgroundColor: {
    type: String,
    default: "bg-gray-25",
  },
  leftBorderColor: {
    type: String,
    default: "#665EA5",
  },
  showLeftBorder: {
    type: Boolean,
    default: true,
  },
});

const toast = useToast();

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    toast.info(`"${text}" copied to clipboard!`, {
      position: "top-right",
      duration: 2000,
    });
  });
};
</script>
